import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const fetchEphemeralUserById = (
  userId: string,
  setEphemeralUser: Function,
  setLoaded: Function,
  language: string
) => {
  setLoaded(false);

  ApiService.get(`ephemeral-evaluations/users/${userId}`)
    .then((resp) => setEphemeralUser(resp.data.ephemeral_evaluations_user))
    .catch((err) => {
      console.error(`Error fetching ephemeral evaluation user ${userId}:`, err);
      setEphemeralUser(null);
      alert(translate(language, "PAGES.EPHEMERAL_USER_DETAIL.ERRORS.FETCH"));
    })
    .finally(() => setLoaded(true));
};
